// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"style_brandLogo__tj0zW"};